import { ListItemButton } from '@mui/material'
import { useMemo } from 'react'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'

import {
	ITEM_BASE_SX,
	ITEM_SELECTED_SX,
	StyledLabel,
	StyledListItemIcon,
} from './styles'

interface Props {
	text: string
	linkPath: string
	isExternalUrl?: boolean
	IconComponent: React.ElementType
	onClick?: () => void
}

const ToolbarItem: React.FC<Props> = ({
	text,
	linkPath,
	isExternalUrl,
	IconComponent,
	onClick,
}) => {
	const { pathname, search = '' } = useLocation()

	const isSameSection = useMemo(() => {
		const questionIdx = linkPath.indexOf('?')
		if (questionIdx !== -1) {
			const linkBase = linkPath.slice(0, questionIdx)
			const linkQuery = linkPath.slice(questionIdx)
			return pathname.startsWith(linkBase) && search === linkQuery
		}
		if (linkPath === '/') {
			return pathname === linkPath
		}
		return pathname.startsWith(linkPath) && search === ''
	}, [linkPath, pathname, search])

	return (
		<ListItemButton
			component={isExternalUrl ? 'a' : Link}
			to={isExternalUrl ? undefined : linkPath}
			href={isExternalUrl ? linkPath : undefined}
			target={isExternalUrl ? '_blank' : undefined}
			key={text}
			disableGutters
			onClick={onClick}
			sx={isSameSection ? ITEM_SELECTED_SX : ITEM_BASE_SX}
		>
			<StyledListItemIcon
				$isSelected={isSameSection}
				data-testid={isSameSection ? 'selected' : 'unselected'}
			>
				<IconComponent />
			</StyledListItemIcon>
			<StyledLabel $isSelected={isSameSection}>{text}</StyledLabel>
		</ListItemButton>
	)
}

export { ToolbarItem }
